import React, { Fragment, useState, useCallback, useEffect } from 'react';
import {
    Row, 
    Col,
    Card,
    ListGroup, 
    ListGroupItem,
    ButtonGroup,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Label,
    FormGroup
} from 'reactstrap';
import Select from 'react-select';

import avatar from '../../../../../assets/utils/images/avatars/avatar.png';

import api from '../../../../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../../Context/Auth/AuthContext';
import { useForm } from 'react-hook-form';

export default function GiftsList(props){
    const {
        receivers
    } = props;

    const { register, handleSubmit, reset } = useForm({});

    const [plans, setPlans] = useState([]);
    const { toggleLoading, currentGroup, authenticated, globalUpdate, setGlobalUpdate } = useAuth();
    const [enableReceiverFilters] = useState(true);
    const [enableEditPlan] = useState(true);

    const [currentPlan, setCurrentPlan] = useState();

    const [modalEditPlan, setModalEditPlan] = useState(false);
    const toggleModalEditPlan = useCallback(() => {
        setModalEditPlan(!modalEditPlan);
    }, [modalEditPlan, setModalEditPlan]);

    const [modalRemovePlan, setModalRemovePlan] = useState(false);
    const toggleModalRemovePlan = useCallback(() => {
        setModalRemovePlan(!modalRemovePlan);
    }, [modalRemovePlan, setModalRemovePlan]);

    const [currentReceiver, setCurrentReceiver] = useState(null);

    const options = () => {
        let options = [];
        // eslint-disable-next-line
        if (receivers) {
            receivers.map((receiver) => {
                options.push(
                    {
                        value: receiver.id,
                        label: receiver.name
                    }
                );
                return receiver;
            });
        }

        options.push({
            value: '',
            label: 'All'
        })
        
        return options;
    }

    const getPlans = useCallback(() => {
        const userInfo = () => {
            if (authenticated.user) {
                return authenticated.user;
            } else {
                return authenticated;
            }
        }

        setPlans([]);
        setCurrentReceiver(null);
        toggleLoading(true);
        api.post(`/ro.team.listGiverPlanGift/${currentGroup.id}`, {
            giverId: userInfo().id
        })
            .then((response) => {
                if (response.data && response.data.length > 0) {
                    setPlans(response.data);
                }
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [currentGroup, setPlans, toggleLoading, authenticated, setCurrentReceiver]);

    const changeReceiver = useCallback((event) => {
        const currentReceiverId = event.value;
        setPlans([]);

        const userInfo = () => {
            if (authenticated.user) {
                return authenticated.user;
            } else {
                return authenticated;
            }
        }

        if (currentReceiverId && currentReceiverId !== '') {
            setCurrentReceiver(currentReceiverId);
            toggleLoading(true);
            api.post(`/ro.team.listGroupPlanGift/${currentGroup.id}`, {
                giverId: userInfo().id,
                receiverId: currentReceiverId
            })
                .then((response) => {
                    if (response.data && response.data.length > 0) {
                        setPlans(response.data);
                    }
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        } else {
            getPlans();
        }
    }, [toggleLoading, currentGroup, setPlans, getPlans, setCurrentReceiver, authenticated]);

    useEffect(() => {
        getPlans();
    }, [getPlans]);

    useEffect(() => {
        if (globalUpdate.planList) {
            getPlans();
            setGlobalUpdate({});
        }
    }, [globalUpdate, setGlobalUpdate, getPlans]);

    const onSubmitEditCallPlan = useCallback(
        async (data) => {
            toggleLoading(true);
            api.patch(`/ro.team.modifyPlanGift/${currentPlan.id}`, {
                receiverId: currentPlan.receiver.id,
                groupId: currentGroup.id,
                plan: {
                    times: data.plan,
                    times_per: data.timePer,
                    period: data.period,
                },
                notes: data.notes,
            })
                .then((response) => {
                    toast.success(`Call edited!`);
                    toggleModalEditPlan();
                    reset(response);
                    if (currentReceiver) {
                        changeReceiver({value: currentReceiver});
                    } else {
                        getPlans();
                    }
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [toggleModalEditPlan, reset, currentGroup.id, toggleLoading, currentPlan, changeReceiver, currentReceiver, getPlans]
    );

    const onSubmitRemoveCall = useCallback(
        async () => {
            toggleLoading(true);
            api.delete(`/ro.team.deletePlanGift/${currentPlan.id}`, {
                data: {
                    gid: currentGroup.id,
                    receiverId: currentPlan.receiver.id
                }
            })
                .then((response) => {
                    toast.success(`Plan removed`);
                    toggleModalRemovePlan();
                    reset(response);
                    if (currentReceiver) {
                        changeReceiver({value: currentReceiver});
                    } else {
                        getPlans();
                    }
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [toggleModalRemovePlan, reset, currentGroup.id, toggleLoading, currentPlan, changeReceiver, currentReceiver, getPlans]
    );

    return (
        <Fragment>
            <Container fluid>
                {enableReceiverFilters && (
                    <Row className="mb-4">
                        <Col lg="12">
                            <Select
                                options={options()}
                                placeholder="Select a Senior"
                                onChange={changeReceiver}
                                defaultValue={{ value: '', label: 'All' }}
                            />
                        </Col>
                    </Row>
                )}                
                <Row>
                    <Col lg="12">
                        <Card className="main-card mb-3">
                            <ListGroup flush>
                                {plans && plans.map((plan) => (
                                    <ListGroupItem key={plan.id}>
                                        <div className="widget-content p-0">
                                            <div className="widget-content-wrapper">
                                                <div className="widget-content-left mr-3">
                                                    <img width={42} className="rounded-circle" src={avatar}
                                                            alt=""/>
                                                </div>
                                                <div className="widget-content-left">
                                                    <div className="widget-heading">
                                                        {plan.receiver.name}
                                                    </div>
                                                    <div className="widget-subheading">
                                                        {plan.plan.times} per {plan.plan.times_per} / At {plan.plan.period}
                                                    </div>
                                                    <div className="widget-subheading">
                                                        {plan.notes}
                                                    </div>
                                                </div>
                                                    <div className="widget-content-right">
                                                        {enableEditPlan && (
                                                            <ButtonGroup size="sm">
                                                                <Button 
                                                                    className="btn-shadow"
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        setCurrentPlan(plan);
                                                                        toggleModalEditPlan();
                                                                    }}
                                                                >
                                                                    Edit
                                                                </Button>
                                                                <Button 
                                                                    className="btn-shadow"
                                                                    color="danger"
                                                                    onClick={() => {
                                                                        setCurrentPlan(plan);
                                                                        toggleModalRemovePlan();
                                                                    }}
                                                                >
                                                                    Remove
                                                                </Button>
                                                            </ButtonGroup>
                                                        )}
                                                        {plan.receiver.phone && (
                                                            <a 
                                                                className="btn-shadow ml-2 btn btn-success"
                                                                color="success"
                                                                href={`tel:${plan.receiver.phone}`}
                                                            >
                                                                Call now
                                                            </a>
                                                        )}
                                                        
                                                    </div>                                  
                                            </div>
                                        </div>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={modalEditPlan} toggle={toggleModalEditPlan}>
                    <ModalHeader toggle={toggleModalEditPlan}>
                        Call Plan
                    </ModalHeader>
                    <ModalBody>
                        {currentPlan && (
                            <Form>
                                <FormGroup row>
                                    <Label for="receiver" sm={2}>
                                        Senior
                                    </Label>
                                    <Col sm={10}>
                                        <input
                                        type="text"
                                        defaultValue={currentPlan.receiver.name}
                                        disabled={true}
                                        className="form-control"
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="date" sm={2}>
                                        Plan
                                    </Label>
                                    <Col sm={3}>
                                        <select
                                            className="form-control"
                                            ref={register}
                                            name="plan"
                                            defaultValue={currentPlan.plan.times}
                                        >
                                            <option>1</option>
                                            <option>2</option>
                                            <option>3</option>
                                            <option>4</option>
                                            <option>5</option>
                                            <option>6</option>
                                            <option>7</option>
                                        </select>
                                    </Col>
                                    <Label sm={3}>Times per</Label>
                                    <Col sm={4}>
                                        <select
                                            className="form-control"
                                            ref={register}
                                            name="timePer"
                                            defaultValue={currentPlan.plan.times_per}
                                        >
                                            <option>Week</option>
                                            <option>Month</option>
                                        </select>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="period" sm={2}>
                                        Call Period
                                    </Label>
                                    <Col sm={10}>
                                        <select
                                            name="period"
                                            id="period"
                                            ref={register}
                                            className="form-control"
                                            defaultValue={currentPlan.plan.period}
                                        >
                                            <option>Afternoon</option>
                                            <option>Morning</option>
                                            <option>Night</option>
                                        </select>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Label for="notes" sm={2}>
                                        Notes
                                    </Label>
                                    <Col sm={10}>
                                        <textarea
                                            name="notes"
                                            id="notes"
                                            ref={register}
                                            className="form-control"
                                            defaultValue={currentPlan.notes}
                                        ></textarea>
                                    </Col>
                                </FormGroup>
                                <div className="text-center">
                                    <Button
                                        className="btn-wide mb-2 mr-2"
                                        size="md"
                                        color="success"
                                        onClick={handleSubmit(onSubmitEditCallPlan)}
                                    >
                                        Edit
                                    </Button>

                                    <Button
                                        className="btn-wide mb-2 mr-2"
                                        size="md"
                                        color="danger"
                                        onClick={toggleModalEditPlan}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalRemovePlan} toggle={toggleModalRemovePlan}>
                    <ModalHeader toggle={toggleModalRemovePlan}>
                        Confirm Remove Call Plan
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-center">
                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="danger"
                                onClick={onSubmitRemoveCall}
                            >
                                Remove
                            </Button>

                            <Button
                                className="btn-wide mb-2 mr-2"
                                size="md"
                                color="primary"
                                onClick={toggleModalRemovePlan}
                            >
                                Cancel
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

            </Container>
        </Fragment>
    );
};
